import axios from "axios";
import React, { useEffect, useState } from "react";
import GetHost from "../lib/GetHost";
import pr from "../util/pr";
import { Select } from "antd";
import "antd/dist/antd.css";

const { Option } = Select;
const host = GetHost();
let result;

function CenterSelect(props) {
  let { width, onCenterChange } = props;
  const [data, setData] = useState([]);  
  width=(width)?parseInt(width):150;  

  useEffect(() => {
    load_data();
  }, []);

  const load_data = async () => {
    result = await axios.post(GetHost() + "/gympass_admin/center_list");    
    setData(result.data);
  };

  const onChange = (value) => {
    onCenterChange(value); // parent
  }

  return (
    <Select style={{width:width}} defaultValue="" onChange={onChange}>
        <Option key="E" value="">
            센터를 선택하세요.
        </Option>
      {data.map((item, index) => {
        return (
           
          <Option key={index} value={item.cid}>
            {item.center} {item.location}
          </Option>
          
        );
      })}
    </Select>
  );
}

// gympass_admin/center_list

export default CenterSelect;

// // 센터목록 셀랙트 박스
// const CenterSelect = () => {
//     return (
//         <Select style={{ width: 200, textAlign: "left" }} defaultValue="" onChange={value => handle_center_change(value)} value={cid}>
//             <Option value="">지점선택</Option>
//             { centers.map((n, i) => {
//                 return (<Option key={i} value={n.value}>{n.label}</Option>);
//             })}
//         </Select>);
// }
